import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
export function PictureLink(t0) {
  const $ = _c(15);
  const {
    url
  } = t0;
  const {
    marketplaceEntity
  } = useReviewContext();
  const {
    details: t1,
    cta,
    ctaAnalytics,
    finishType
  } = marketplaceEntity;
  const {
    applyLink
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "review_how_to_decide",
      position: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== ctaAnalytics) {
    t3 = {
      ...ctaAnalytics,
      section: t2
    };
    $[1] = ctaAnalytics;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined;
  const t5 = cta.type !== EntityPlacementCtaTypeEnum.ApplyNow;
  let t6;
  if ($[3] !== cta.type) {
    t6 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH] : [];
    $[3] = cta.type;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== url) {
    t7 = <CdnImage alt="alt" src={url} fill={true} sizes={IMAGE_SIZES.MINI_PRODUCT_CARD} />;
    $[5] = url;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== applyLink || $[8] !== finishType || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <CtaLink analytics={t3} type="PRODUCT_IMAGE" href={applyLink} rel={t4} target="_blank" finishType={finishType} isReview={t5} parameterActions={t6}>{t7}</CtaLink>;
    $[7] = applyLink;
    $[8] = finishType;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}